

























import Presenter from './presenters/Presenter.vue';
import { CUSTOM_ATTRIBUTE_MAPPINGS } from './presenters/mappings';
import Layout from './configuration/layout/Layout.vue';
import {
  LayoutSettings,
  DEFAULT_LAYOUT_SETTINGS,
  ComponentTypes,
  getRequiredConfig,
  getDefaultPosition,
} from './configuration/layout/model';

export default {
  name: 'CaDetails',
  components: {
    Layout,
    Presenter,
    SectionItem: () => import('./configuration/layout/items/SectionItem.vue'),
    DefaultItem: () => import('./configuration/layout/items/DefaultItem.vue'),
  },
  props: {
    layout: {
      type: Object,
      required: false,
      default: () => {},
    },
    objectId: {
      type: Number,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    customAttributes: {
      type: Array,
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
  },

  data() {
    let settings: LayoutSettings = {
      columns: 4,
      itemsPerRow: 4,
      rowHeight: 65,
      isDraggable: false,
      isResizable: false,
      verticalCompact: true,
      margin: [30, 30],
    };
    return {
      CUSTOM_ATTRIBUTE_MAPPINGS,
      layoutSettings: settings,
      layoutItems: [],
    };
  },

  computed: {
    items() {
      const alreadySaved = this.attributesLayout.length > 0;
      const items = this.customAttributes.map(item => {
        const layout = this.attributesLayout.find(attr => '__custom__:' + attr.attr_id === item.editLink.attrKey);
        if (!layout) {
          let config = getRequiredConfig(item.editLink.attrKey);
          if (alreadySaved) {
            // if its a new attribute, put it on top left
            const defaultPosition = getDefaultPosition();
            config = Object.assign(config, defaultPosition);
          }

          return {
            ...item,
            ...config,
            componentType: item.presenterName,
          };
        }

        return {
          ...item,
          ...layout.config,
          i: item.editLink.attrKey,
          minH: layout.config.h,
          componentType: item.presenterName,
        };
      });

      const sectionMap = {};
      this.sectionsLayout.forEach(section => {
        sectionMap[section.id] = {
          ...section.config,
          title: section.title,
          id: section.id,
          i: `section_${section.id}`,
          minW: section.config.w,
          componentType: ComponentTypes.section,
          isReadonly: true,
          isDraggable: false,
          isResizable: false,
        };
      });

      items.splice(0, 0, ...Object.values(sectionMap));
      return items;
    },
    attributesLayout() {
      return this.layout.attributes;
    },
    sectionsLayout() {
      return this.layout.sections;
    },
  },

  created() {
    this.layoutItems = this.items;
  },

  methods: {
    async increaseHeight(event, item) {
      await this.$nextTick();
      if (event.currentTarget.parentNode.classList.value.includes('parent__showall')) {
        // expand grid
        let offsetHeight = 0;
        event.currentTarget.parentNode.children.forEach(el => {
          offsetHeight += el.offsetHeight;
        });
        const rowHeight = this.layoutSettings.rowHeight || DEFAULT_LAYOUT_SETTINGS.rowHeight || 1;
        const rows = Math.ceil((offsetHeight + 30) / (rowHeight + 30));
        if (item.h < rows) {
          while (item.h < rows) {
            // have to increase row by row to allow the component to render and push
            // down the items under it.
            item.h += 1;
            this.$refs.layout.refreshLayout();
          }
          this.layoutItems = [...this.layoutItems];
        }
        return;
      }
      // collapse grid
      if (item.h !== item.minH) {
        item.h = item.minH || 1;
        this.layoutItems = [...this.layoutItems];
        this.$refs.layout.refreshLayout();
      }
    },
  },
};
